export var HistoryType;
(function (HistoryType) {
    HistoryType["UPDATE"] = "update";
    HistoryType["REPLACE"] = "replace";
    HistoryType["ADD"] = "add";
    HistoryType["REMOVE"] = "remove";
})(HistoryType || (HistoryType = {}));
